export default "__VITE_ASSET__MoyI8Qbn__"